module.exports = __webpack_public_path__ + "static/media/13_tn.680fdb48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/13_tn.jpg
// module id = 649
// module chunks = 0